export enum DisplayAnalysisType {
  Linear = `linear`,
  Logarithmic = `logarithmic`,
}

export enum DisplayPlotStyle {
  Stacked = `stacked`,
  Standard = `standard`,
}
